import { Formik, FormikValues } from 'formik'
import { useHistory } from 'react-router-dom'
import { ThunkDispatch } from 'redux-thunk'
import { useDispatch, useSelector } from 'react-redux'
import { Alert, Button, Form, Spacer } from '@pinchenterprisesnpm/friday-ui'
import { IAuthLogin } from 'models/Auth'
import { login, LoginActions } from 'data/Auth/thunks'
import {
  selectAuthIsAuth,
  selectAuthIsFetching,
  selectAuthMeta,
  selectAuthUserRole,
} from 'data/Auth/selectors'
import { useLayoutEffect } from 'react'
import { isAdminUserByRoleName } from 'helpers/authHelpers'
import { faLockAlt } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Logo from 'img/login_logo.png'
import HeaderImg from 'img/login_person_work.svg'
import { TLoginChildrenProps } from '..'
import {
  OuterWrapper,
  LoginWrapper,
  LoginHeaderWrapper,
  WelcomeBackWrapper,
  LoginContentWrapper,
  LoginHeaderLabel,
  ForgotPasswordWrapper,
  LoginHeaderWelcomeBackImage,
  UpshiftLogo,
  UpshiftLogoWrapper,
} from './style'
import { loginFormValidationSchema } from './utils'

const { Input } = Form

const LoginForm = ({ handleSwitchScreen }: TLoginChildrenProps) => {
  const history = useHistory()
  const isFetching = useSelector(selectAuthIsFetching)
  const meta = useSelector(selectAuthMeta)
  const isAuth = useSelector(selectAuthIsAuth)
  const userRole = useSelector(selectAuthUserRole)
  const dispatch = useDispatch<ThunkDispatch<any, any, LoginActions>>()

  useLayoutEffect(() => {
    if (isAuth) {
      if (isAdminUserByRoleName(userRole)) {
        history.push('/shifts')
      } else {
        history.push('/onboarder/upshifter_list')
      }
    }
  }, [isAuth, history, userRole])

  /**
   *
   * @param values Object containing the username / password combination
   */
  const handleSubmit = (values: FormikValues) => {
    const { email, password } = values
    const authLoginParams: IAuthLogin = {
      email: email.trim().toLowerCase(),
      password,
    }
    dispatch(login(authLoginParams))
  }

  return (
    <OuterWrapper>
      <LoginWrapper>
        <div>
          <LoginHeaderWrapper>
            <WelcomeBackWrapper>
              <h3>Welcome Back !</h3>
              <div>Sign in to continue to Upshift.</div>
            </WelcomeBackWrapper>
            <LoginHeaderWelcomeBackImage
              src={HeaderImg}
              alt='Welcome Back! Please sign in to continue to Upshift.'
            />
          </LoginHeaderWrapper>
          <UpshiftLogoWrapper>
            <UpshiftLogo src={Logo} alt='Upshift logo' />
          </UpshiftLogoWrapper>
        </div>
        <LoginContentWrapper>
          <LoginHeaderLabel>LOGIN</LoginHeaderLabel>
          {meta.message && <Alert type='danger' message={meta.message} isClosable />}
          <span>Use your credentials to login and use the platform</span>

          <Spacer />
          <Formik
            initialValues={{ email: '', password: '' }}
            onSubmit={(values) => handleSubmit(values)}
            validationSchema={loginFormValidationSchema}
          >
            {(formikProps) => {
              const { errors, handleChange, handleSubmit, values, submitForm, touched } =
                formikProps
              return (
                <Form onSubmit={handleSubmit}>
                  <Input
                    type='text'
                    placeholder='Your email'
                    onChange={handleChange}
                    value={values.email}
                    name='email'
                    errorMessage={touched.email && errors.email ? errors.email : undefined}
                  />

                  <Spacer />

                  <Input
                    type='password'
                    placeholder='Your password'
                    onChange={handleChange}
                    value={values.password}
                    name='password'
                    errorMessage={touched.password && errors.password ? errors.password : undefined}
                  />

                  <Spacer space='xl' />

                  <Button
                    type='primary_300'
                    htmlType='submit'
                    isLoading={isFetching}
                    isDisabled={isFetching}
                    isBlock
                  >
                    Login
                  </Button>
                </Form>
              )
            }}
          </Formik>
          <Spacer space='xl' />
          <ForgotPasswordWrapper onClick={handleSwitchScreen}>
            <FontAwesomeIcon icon={faLockAlt} />
            <Spacer type='horizontal' />
            Forgot Password?
          </ForgotPasswordWrapper>
        </LoginContentWrapper>
      </LoginWrapper>
    </OuterWrapper>
  )
}

export default LoginForm
